import React, { useEffect, useState } from 'react';
import { Image } from 'antd';

export const GlobalImagePreviewer: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [src, setSrc] = useState('');

  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // Locate the clicked image or closest ancestor img tag
      const img = target.closest('img');
      if (!img) return;

      // Exclude images explicitly opted out of previewing
      if (
        img.classList.contains('no-preview') || 
        img.closest('.no-preview') || 
        img.closest('.ant-image-preview') ||
        img.closest('.ant-image-preview-operations') ||
        img.closest('.ant-image-operations-wrapper')
      ) {
        return;
      }

      // Ignore small user interface elements, icons, and flags (under 32px)
      const rect = img.getBoundingClientRect();
      if (rect.width < 32 || rect.height < 32) {
        return;
      }

      // Halt default behaviors and trigger the modal preview
      e.preventDefault();
      e.stopPropagation();

      setSrc(img.src);
      setVisible(true);
    };

    // Dynamically apply previewable styling to images when hovered
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const img = target.closest('img');
      if (!img) return;

      if (
        img.classList.contains('no-preview') || 
        img.closest('.no-preview') || 
        img.closest('.ant-image-preview') ||
        img.closest('.ant-image-preview-operations') ||
        img.closest('.ant-image-operations-wrapper')
      ) {
        return;
      }

      const rect = img.getBoundingClientRect();
      if (rect.width >= 32 && rect.height >= 32) {
        img.classList.add('admin-previewable-img');
      }
    };

    // Add event listeners on capturing phase to catch clicks early
    document.addEventListener('click', handleGlobalClick, true);
    document.addEventListener('mouseover', handleMouseOver, true);
    
    return () => {
      document.removeEventListener('click', handleGlobalClick, true);
      document.removeEventListener('mouseover', handleMouseOver, true);
    };
  }, []);

  return (
    <div style={{ display: 'none' }}>
      <Image
        src={src}
        preview={{
          visible,
          src,
          onVisibleChange: (val) => {
            setVisible(val);
          },
        }}
      />
    </div>
  );
};

export default GlobalImagePreviewer;
